export enum UIDataStoreIdForTemplateWorkflows {
  filteredId = '53f535fb-e853-4c28-b656-2a65961d1f01'
}
